module.exports = __webpack_public_path__ + "static/flumph-37733ce32acc3c7ecef1c82f2c792e5e.jpg";